module.exports = __webpack_public_path__ + "img/inpost-auto.f67f5435.png";